export default __webpack_public_path__ + "static/media/register-bg.05c5aa67.jpg";